<template>
    <BreadCrumb PageTitle="Liste des catégories" />
    <ListeCategProduit/>
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeCategProduit from "@/components/CategorieProduit/ListeCategProduit.vue";

    export default defineComponent({
        name: "ListeCategoriePPage",
        components: {
            BreadCrumb,
            ListeCategProduit,
        },
    });
</script>